var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 19.1204C15.4271 19.1204 14.8537 18.9014 14.4165 18.4644L0.657185 4.70499C-0.218085 3.82972 -0.218085 2.41062 0.657185 1.5357C1.5321 0.660788 2.95092 0.660788 3.82626 1.5357L16.0006 13.7108L28.1751 1.53613C29.0504 0.661213 30.469 0.661213 31.3439 1.53613C32.2196 2.41104 32.2196 3.83014 31.3439 4.70541L17.5848 18.4648C17.1474 18.9019 16.5739 19.1204 16.0006 19.1204Z",
    fill: "currentcolor"
  })));
};
export default SvgArrowDown;